export const colors = {
  white: '#ffffff',
  black: '#1d2129',
  beige: '#F7EAD2',
  red: '#854852',
  green: '#394B43',
  gray: 'gray',
};
